module.exports = new __parcel__URL__("jsm-try-end-learn.c322b649.svg").toString();